import { Azing } from '@azing/user';

export class AzingUserService {
  azing: Azing;

  constructor() {
    this.azing = (window as any).azing as Azing;
  }
}
